import React, { useMemo, FC } from 'react';
import { TNewsListingProps, TSelectedNewsFilters } from './types/newsListing.types';
import { NewsListingModel } from './models/newsListing.model';
import DesktopFilter from './components/desktopFilter';
import { BreakpointsInPx } from '../../constants/breakpoints.constants';
import MobileFilter from './components/mobileFilter';
import { useLocation, useNavigate } from 'react-router';
import { QueryParamsConst } from '../../constants/query-params.constants';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import { updateSearchResults } from '../../hooks/useQueryParams.effect';
import NewsCardList from './components/newsCardList';
import NoMatch from '../@shared/filters/components/noMatch';
import useMedia from '../../lib/custom-hooks/useMediaQuery';
import { NewsListingPlaceholderImgContext } from './components/newsListingContext';
import Pagination from '../@shared/pagination';
import AnalyticsVisibleEvent from '../@shared/analyticsVisibleEvent';

const NewsListing: FC<TNewsListingProps> = (props) => {
  const model = new NewsListingModel(props);
  const isWide = useMedia(`(min-width: ${BreakpointsInPx['lg']})`);
  const location = useLocation();
  const navigate = useNavigate();
  const filterQueryString = location?.search;
  const filterParams = useMemo(() => new URLSearchParams(location?.search), [filterQueryString]);
  const year = filterParams.get(QueryParamsConst.YEAR) || '';
  const line = model.findFilterByName('line')?.hidden ? '' : filterParams.get(QueryParamsConst.LINE) || '';
  const type = model.findFilterByName('type')?.hidden ? '' : filterParams.get(QueryParamsConst.TYPE) || '';
  const filter1 = model.findFilterByName('filter1')?.hidden ? '' : filterParams.get(QueryParamsConst.FILTER1) || '';
  const pageNo = filterParams.get(QueryParamsConst.PAGE) || '1';
  const noOfCardsPerPage = 6;
  const totalPageCount = Math.ceil(model.counter / noOfCardsPerPage);

  const { YEAR, LINE, TYPE, FILTER1 } = QueryParamsConst;
  const selectedFilters: TSelectedNewsFilters = {
    [YEAR]: year,
    [LINE]: line,
    [TYPE]: type,
    [FILTER1]: filter1,
  };

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  const onPaginationChange = (selectedPage: number): void =>
    updateSearchResults(navigate, { [QueryParamsConst.PAGE]: selectedPage.toString() });

  return (
    <NewsListingPlaceholderImgContext.Provider value={model?.defaultCardImage}>
      <div className="news-listing">
        <AnalyticsVisibleEvent rendering={props.rendering} title={'Filter'} template={'News Filter'}>
          {isWide ? (
            <DesktopFilter model={model} selectedFilters={selectedFilters} />
          ) : (
            <MobileFilter model={model} selectedFilters={selectedFilters} />
          )}
        </AnalyticsVisibleEvent>
        {model?.items?.length === 0 ? (
          <NoMatch
            titleDictionaryKey="cnhi-news-no-matches-found-title"
            descriptionDictionaryKey="cnhi-news-no-matches-found-description"
          />
        ) : (
          <div className="news-listing__card-container">
            <NewsCardList items={model?.items} rendering={props.rendering} socialMediaBarProps={model.socialMediaBarProps} />
          </div>
        )}
        <Pagination currentPage={parseInt(pageNo)} pages={totalPageCount} goToPage={onPaginationChange} />
      </div>
    </NewsListingPlaceholderImgContext.Provider>
  );
};

export default NewsListing;
